import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import * as React from 'react';

import Typography from './HomeTypography';

export const Place = () => {
  return (
    <Container component="section" sx={{ mt: 10, display: 'flex' }}>
      <Grid container>
        <Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              bgcolor: 'primary.main',
              py: 8,
              px: 3,
            }}
          >
            <Box sx={{ maxWidth: 500 }}>
              <Typography
                variant="h3"
                component="h3"
                gutterBottom
                fontWeight="medium"
                color="white"
              >
                Lieu du congrès
              </Typography>
              <Typography variant="h5" color="grey.200">
                Auberge de jeunesse de Rosière-près-Troyes
              </Typography>
              <Typography variant="subtitle1" color="grey.100">
                Chemin Sainte-Scholastique 10430 Rosières-prés-Troyes
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: { md: 'block', xs: 'none' }, position: 'relative' }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -67,
              left: -67,
              right: 0,
              bottom: 0,
              width: '100%',
              background: 'url(/home/background-dots.png)',
            }}
          />
          <Box
            component="img"
            src="/home/place.jpg"
            alt="call to action"
            sx={{
              position: 'absolute',
              top: -28,
              left: -28,
              right: 0,
              bottom: 0,
              width: '100%',
              maxWidth: 600,
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};
